module.exports = __webpack_public_path__ + "img/uploadfailed.43ba28b9.svg";